import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Briefcase, TrendingUp, Users, Shield } from 'lucide-react';
export function CypressSection() {
  return <Section id="current-role" variant="navy" data-id="element-145">
      <SectionHeader title="Current Operations" subtitle="Cypress International" data-id="element-146" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-147">
        <Reveal data-id="element-148">
          <div className="space-y-6" data-id="element-149">
            <div className="inline-block px-3 py-1 border border-gold-500/30 bg-gold-500/10 rounded-sm" data-id="element-150">
              <span className="text-gold-500 font-heading text-xs tracking-widest uppercase" data-id="element-151">
                Present Role
              </span>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white uppercase leading-tight" data-id="element-152">
              Vice President, DoD & Federal Logistics
            </h3>
            <p className="text-xl text-slate-300 font-light" data-id="element-153">
              Leading strategic consulting and business development for defense
              original equipment manufacturers (OEMs) and federal contractors.
            </p>
            <p className="text-slate-400 leading-relaxed" data-id="element-154">
              Spearheading growth initiatives and providing expert counsel on
              sustainment, lifecycle strategy, and government acquisition
              processes. Bridging the gap between industry capabilities and
              Department of Defense requirements to ensure warfighter readiness.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-155">
          <Reveal delay={200} data-id="element-156">
            <Card className="h-full" data-id="element-157">
              <TrendingUp className="text-gold-500 w-8 h-8 mb-4" data-id="element-158" />
              <h4 className="text-2xl font-bold text-white mb-1" data-id="element-159">$1M+</h4>
              <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-160">
                Revenue Growth
              </p>
            </Card>
          </Reveal>

          <Reveal delay={300} data-id="element-161">
            <Card className="h-full" data-id="element-162">
              <Users className="text-gold-500 w-8 h-8 mb-4" data-id="element-163" />
              <h4 className="text-2xl font-bold text-white mb-1" data-id="element-164">0 to 9</h4>
              <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-165">
                Client Portfolio Growth
              </p>
            </Card>
          </Reveal>

          <Reveal delay={400} data-id="element-166">
            <Card className="h-full" data-id="element-167">
              <Briefcase className="text-gold-500 w-8 h-8 mb-4" data-id="element-168" />
              <h4 className="text-2xl font-bold text-white mb-1" data-id="element-169">30+</h4>
              <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-170">
                DoD OEMs Advised
              </p>
            </Card>
          </Reveal>

          <Reveal delay={500} data-id="element-171">
            <Card className="h-full" data-id="element-172">
              <Shield className="text-gold-500 w-8 h-8 mb-4" data-id="element-173" />
              <h4 className="text-2xl font-bold text-white mb-1" data-id="element-174">TS/SCI</h4>
              <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-175">
                Active Clearance
              </p>
            </Card>
          </Reveal>
        </div>
      </div>
    </Section>;
}